module.exports = __webpack_public_path__ + "static/media/brand-car-wreck2.2d8e93aa.png";